import { render, staticRenderFns } from "./EternityAutobuyerBox.vue?vue&type=template&id=56211cc8&scoped=true"
import script from "./EternityAutobuyerBox.vue?vue&type=script&lang=js"
export * from "./EternityAutobuyerBox.vue?vue&type=script&lang=js"
import style0 from "./EternityAutobuyerBox.vue?vue&type=style&index=0&id=56211cc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56211cc8",
  null
  
)

export default component.exports